<div class="content-container">
  <div class="selection-instructions">
    @if(isMobile$ | async) {
      <h3>Who's here today?</h3>
    }
    @if(instructions$ | async) {
      <p> {{instructions$ | async}} </p>
    }
  </div>

  @if (shouldRenderNBTHAlertBanner()) {
    <ng-content></ng-content>
  }

  <div class="participants">
    @for (nonSa of nonSigningAgentsWithDisplayName$ | async; track nonSa) {
      <app-welcome-participant [participant]="nonSa">
      </app-welcome-participant>
    }
  </div>
  @if (hasMultiplenonSigningAgents$ | async) {
    <p class="tip">
      Tip: If checking in on separate devices, make sure you are in different rooms or
      locations. This will help to prevent audio issues.
    </p>
  }

  @if (nonSaWelcomePageButtonVm$ | async; as buttonVm) {
    <div class="button-container">
      @if (buttonVm.isBeginCheckInButtonVisible) {
        <app-button
          (buttonClick)="beginCheckIn()"
          [type]="'primary'"
      [ariaLabel]="
        (isUserCheckInSequenceEmpty$ | async)
          ? 'button disabled until participant selection is made'
          : null
      "
          [isDisabled]="isUserCheckInSequenceEmpty$ | async"
          [dataTestId]="'begin-check-in-button'"
          >Begin Check In</app-button
          >
        }
        @if (buttonVm.isGoToWaitingRoomButtonVisible) {
          <app-button
            (buttonClick)="goToWaitingRoom()"
            [type]="'primary'"
            [dataTestId]="'go-to-waiting-room-button'"
            >Go to Waiting Room</app-button
            >
          }
          @if (buttonVm.isGoToSigningRoomButtonVisible) {
            <app-button
              (buttonClick)="goToSigningRoom()"
              [type]="'primary'"
              [dataTestId]="'go-to-signing-room-button'"
              >Go to Signing Room</app-button
              >
            }
          </div>
        }

        @if (nonSaWelcomePageRejoinButtonVm$ | async; as rejoinButtonVm) {
          <div class="button-container">
            @if (rejoinButtonVm.isRejoinButtonVisible) {
              <app-button
                (buttonClick)="rejoin()"
                [type]="'primary'"
                [isDisabled]="isUserCheckInSequenceEmpty$ | async"
                [dataTestId]="'rejoin-waiting-room-button'"
                >Attempt to Rejoin Signing</app-button
                >
              }
            </div>
          }
        </div>
